import optimizationModule from "./optimizationModule"
import server from "../server"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"

optimizationModule.service("r2OptimizationService", [
    "$http",
    "loadingService",
    "remoteExceptionHandler",
    "$q",
    function ($http, loadingService, remoteExceptionHandler, $q) {
        return function (trips, deliveryUnits, config, restrictions) {
            var tripsIds = arrays.map(trips, function (nodeIdentifier) {
                return nodeIdentifier.id
            })
            var deliveryUnitsIds = arrays.map(deliveryUnits, function (nodeIdentifier) {
                return nodeIdentifier.id
            })

            return optimize(tripsIds, deliveryUnitsIds, config, restrictions)
                .catch(function (e) {
                    remoteExceptionHandler()(e)
                    return $q.reject()
                })
        }

        function optimize(tripsIds, deliveryUnitsIds, config, restrictions) {
            if (restrictions) {
                return loadingService($http.post(server.getServiceUrl("doOptimizeWithRestrictions"), {
                    deliveryUnitIds: deliveryUnitsIds,
                    routingConfigId: config.routingConfig.id,
                    tripIds: tripsIds,
                    restrictions: restrictions
                }))
            }
            return loadingService($http.post(server.getServiceUrl("doOptimize"), {
                deliveryUnitIds: deliveryUnitsIds,
                routingConfigId: config.routingConfig.id,
                tripIds: tripsIds
            }))
        }
    }])




